<template>
	<div>
		<!-- This example requires Tailwind CSS v2.0+ -->
		<div class="flex items-center justify-between">
			<span class="flex-grow flex flex-col" id="toggleLabel">
				<span class="text-base md:text-sm font-medium text-gray-900">{{
					label
				}}</span>
				<span
					class="hidden md:block text-sm leading-normal text-gray-500"
					v-if="description"
					>{{ description }}</span
				>
			</span>
			<span class="relative z-0 inline-flex shadow-sm rounded-md ml-4">
				<button
					v-for="(option, key) in options"
					type="button"
					:key="key"
					class="relative inline-flex items-center px-4 py-2 border text-sm font-medium focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
					@click="select(option)"
					:class="{
						'-ml-px': key,
						'rounded-l-md': !key,
						'rounded-r-md': key === options.length - 1,
						'bg-cyan border-cyan text-white': isSelected(option),
						'border-gray-300 bg-white text-gray-300 hover:bg-gray-50': !isSelected(
							option
						),
					}"
				>
					{{ option.label }} for 
				</button>
			</span>
		</div>
		<div class="block md:hidden pt-3">
			<span class="text-sm leading-normal text-gray-500" v-if="description">{{
				description
			}}</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ButtonGroup',
	computed: {
		localValue: {
			get() {
				return this.value
			},
			set(localValue) {
				this.$emit('input', localValue)
			},
		},
	},
	props: {
		options: {
			type: Array,
			default: () => [],
		},
		value: {
			type: String | Number,
			default: null,
		},
		name: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: '',
		},
		description: {
			type: String,
			default: null,
		},
	},

	methods: {
		isSelected(option) {
			return option.value === this.localValue
		},
		select(option) {
			this.localValue = option.value
			this.$emit('change')
		},
	},
}
</script>

<style scoped></style>
